


















import Vue from 'vue';
import HelpList from '@/parts/app/HelpList.vue';

export default Vue.extend({
  name: 'Help',
  components: {
    HelpList,
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  methods: {
    helplink(url: string) {
      const article = this.$route.params.article || '';
      if (url !== article) {
        if (url) {
          // パラメータがあれば該当ヘルプ記事へ遷移
          this.$router.push({ name: 'Help', params: { article: url }});
        } else {
          // パラメータがなければヘルプ一覧へ戻る
          this.$router.push({ name: 'Help' });
        }
      }
    },
  },
});


